import { render } from "./VisionMission.vue?vue&type=template&id=6836bf09"
import script from "./VisionMission.vue?vue&type=script&lang=js"
export * from "./VisionMission.vue?vue&type=script&lang=js"

import exportComponent from "D:\\helmi\\blitarenergi\\vue\\companyprofile\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__